import React, { useRef, useEffect } from 'react';

import ProgressPopoverContent from './ProgressPopoverContent';

import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Button from 'chameleon/ui-stack/ui/base/button';
import './StudentViewAll.scss';

const StudentViewAll = (props) => {
  const { label = 'View All', actionButtonRef, assessmentId, header } = props;
  const ref = useRef();

  useEffect(() => {
    actionButtonRef.current[assessmentId] = ref.current;
  }, [ref.current]);

  return (
    <div className="assessment-progress">
      <PopOver
        closeButtonSize="small"
        isNarrow
        ref={ref}
        trigger={(buttonProps, isOpen, triggerRef) => {
          return (
            <Button
              {...buttonProps}
              isPrimary
              tabIndex={0}
              accessibility={{
                'aria-label': `${label} ${header}`,
              }}
              ref={triggerRef}
            >
              {label}
            </Button>
          );
        }}
      >
        <ProgressPopoverContent {...props} />
      </PopOver>
    </div>
  );
};

export default StudentViewAll;
